<article>
  <ng-content select="lib-product-card-bullet-list-header"></ng-content>
  <section role="list">
    <ng-content select="lib-product-card-bullet-list-item"></ng-content>
  </section>
</article>
